import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PickupProfileState {
    selectedView: string;
}

const initialState: PickupProfileState = {
    selectedView: 'info',
};

const pickupProfileSlice = createSlice({
    name: 'pickupProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = pickupProfileSlice.actions;
export default pickupProfileSlice.reducer;